// ─────────────────────────────────────────────────────────────────
// Glass-i — Expense Entry constants (Stage 6B.7).
// ─────────────────────────────────────────────────────────────────

export const EXPENSE_TYPES = [
  { value: 'paid',   label: 'Paid (cash/bank)' },
  { value: 'credit', label: 'Credit (vendor bill)' }
];
export const EXPENSE_TYPE_LABEL = {
  paid: 'Paid', credit: 'Credit'
};
export const EXPENSE_TYPE_COLOR = {
  paid: 'cyan', credit: 'gold'
};

export const SUPPLY_TYPES = [
  { value: 'intra_state', label: 'Intra-state (CGST + SGST)' },
  { value: 'inter_state', label: 'Inter-state (IGST)' }
];

// Same modes as Payment Voucher.
export const PAYMENT_MODES = [
  { value: 'cash',       label: 'Cash'       },
  { value: 'bank',       label: 'Bank'       },
  { value: 'upi',        label: 'UPI'        },
  { value: 'cheque',     label: 'Cheque'     },
  { value: 'rtgs',       label: 'RTGS'       },
  { value: 'neft',       label: 'NEFT'       },
  { value: 'imps',       label: 'IMPS'       },
  { value: 'adjustment', label: 'Adjustment' }
];
export const PAYMENT_MODE_LABEL = Object.fromEntries(
  PAYMENT_MODES.map((m) => [m.value, m.label])
);

export const STATUSES = [
  { value: 'draft',     label: 'Draft',     color: 'default' },
  { value: 'posted',    label: 'Posted',    color: 'green'   },
  { value: 'cancelled', label: 'Cancelled', color: 'red'     }
];
export const STATUS_COLOR = Object.fromEntries(
  STATUSES.map((s) => [s.value, s.color])
);
export const STATUS_LABEL = Object.fromEntries(
  STATUSES.map((s) => [s.value, s.label])
);

export const PAYMENT_STATUS_LABEL = {
  unpaid:  'Unpaid',
  partial: 'Partial',
  paid:    'Paid'
};
export const PAYMENT_STATUS_COLOR = {
  unpaid:  'orange',
  partial: 'gold',
  paid:    'green'
};

// Standard GST rates seeded by Stage 6B.1; the operator can also type
// a custom value into the InputNumber, so this is just a helper for
// the dropdown.
export const GST_RATES = [0, 5, 12, 18, 28];

export function formatINR(n) {
  const v = Number(n) || 0;
  return v.toLocaleString('en-IN', {
    minimumFractionDigits: 2, maximumFractionDigits: 2
  });
}
